
// listing & create route
const ProductsList = () =>
  import("./creation/index.vue");
const CreatePage = () =>
  import("./creation/_pages/create.vue");
const ProductViewPage = () =>
  import("./creation/_pages/view.vue");
const ProductBarcodePage = () =>
  import("./creation/_pages/barcode.vue");
const GenerateBarcodePage = () =>
  import("./creation/generate-barcodes.vue");

// product categories
const CategoriesList = () =>
  import("./categories/index.vue");
const CategoriesProductsList = () =>
  import("./categories/products-list.vue");
const CategoriesCreatePage = () =>
  import("./categories/_pages/create.vue");
const CategoryViewPage = () =>
  import("./categories/_pages/view.vue");
const CategoriesImport = () =>
  import("./categories/import.vue");

// sub categories
const SubCategories = () =>
  import("./sub-categories/index.vue");
const CreateSubCategory = () =>
  import("./sub-categories/_pages/create.vue");
const ViewSubCategory = () =>
  import("./sub-categories/_pages/view.vue");

// brands
const BrandsList = () =>
  import("./brands/index.vue");
const BrandCreatePage = () =>
  import("./brands/_pages/create.vue");
const BrandViewPage = () =>
  import("./brands/_pages/view.vue");

// products import
const ImportPage = () =>
  import("./import/index.vue");
const CodesListPage = () =>
  import("./import/codes-list.vue");
const ImportUomStockPage = () =>
  import("./import/uom-stock.vue");
const ImportNonUomStockPage = () =>
  import("./import/non-uom-stock.vue");
const ImportBranchStockPage = () =>
  import("./import/branch-stock.vue");
const CodesImportPage = () =>
  import("./import-codes/index.vue");
const CheckMissingCodes = () =>
  import("./check-missing-codes.vue");

const ImportFikiriaStock = () =>
  import("./fikiria-stock/index.vue");

// makes
const makesIndex = () =>
  import("./makes/index.vue");
const CreateMake = () =>
  import("./makes/_pages/create.vue");
const ViewMake = () =>
  import("./makes/_pages/view.vue");

// colors
const colorsIndex = () =>
  import("./colors/index.vue");
const CreateColor = () =>
  import("./colors/_pages/create.vue");
const ViewColor = () =>
  import("./colors/_pages/view.vue");

// product types
const typesIndex = () =>
  import("./types/index.vue");
const CreateType = () =>
  import("./types/_pages/create.vue");
const ViewType = () =>
  import("./types/_pages/view.vue");

// product models
const modelsIndex = () =>
  import("./models/index.vue");
const CreateModel = () =>
  import("./models/_pages/create.vue");
const ViewModel = () =>
  import("./models/_pages/view.vue");

export default [
  // make
  {
    path: "/makes",
    component: makesIndex,
  },
  {
    path: "/new-make",
    component: CreateMake,
  },
  {
    path: "/make/:id",
    component: ViewMake,
  },
  // color
  {
    path: "/colors",
    component: colorsIndex,
  },
  {
    path: "/new-color",
    component: CreateColor,
  },
  {
    path: "/color/:id",
    component: ViewColor,
  },
  // type
  {
    path: "/product-types",
    component: typesIndex,
  },
  {
    path: "/new-product-type",
    component: CreateType,
  },
  {
    path: "/product-type/:id",
    component: ViewType,
  },
  // end of type
  // models 
  {
    path: "/product-models",
    component: modelsIndex,
  },
  {
    path: "/new-product-model",
    component: CreateModel,
  },
  {
    path: "/product-model/:id",
    component: ViewModel,
  },
  // end of models
  {
    path: "/import-fikiria-stock",
    component: ImportFikiriaStock,
  },
  {
    path: "/check-missing-codes",
    component: CheckMissingCodes,
  },
   {
    path: "/product-codes-list",
    component: CodesListPage,
  },
  {
    path: "/products",
    name: "ProductsPage",
    component: ProductsList,
  },
  {
    path: "/generate-barcodes",
    component: GenerateBarcodePage,
  },
  {
    path: "/new-product",
    name: "NewProductPage",
    component: CreatePage,
  },
  {
    path: "/sub-categories",
    component: SubCategories,
  },
  {
    path: "/new-sub-category",
    component: CreateSubCategory,
  },
  {
    path: "/sub-category/:id",
    component: ViewSubCategory,
  },
  {
    path: "/product-categorization",
    component: CategoriesProductsList,
  },
  {
    path: "/product/categories",
    name: "CategoriesPage",
    component: CategoriesList,
  },
  {
    path: "/product/categories/import",
    component: CategoriesImport,
  },
  {
    path: "/new-category",
    name: "NewCategoryPage",
    component: CategoriesCreatePage,
  },
  {
    path: "/brands",
    component: BrandsList,
  },
  {
    path: "/new-brand",
    component: BrandCreatePage,
  },
  {
    path: "/brand/:id",
    component: BrandViewPage,
  },
  {
    path: "/products/import",
    name: "ImportPage",
    component: ImportPage,
  },
  {
    path: "/import-uom-stock",
    component: ImportUomStockPage,
  },
  {
    path: "/import-non-uom-stock",
    component: ImportNonUomStockPage,
  },
  {
    path: "/import-branch-stock",
    component: ImportBranchStockPage,
  },
  {
    path: "/import/product/codes",
    component: CodesImportPage,
  },
  {
    path: "/product-category/:id",
    name: "CategoryViewPage",
    component: CategoryViewPage,
  },
  {
    path: "/product/:id",
    name: "ProductViewPage",
    component: ProductViewPage,
  },
  {
    path: "/product-barcode/:id",
    component: ProductBarcodePage,
  },
];
